import React from "react";

import locations from "@/constants/dealLocations";
import { createGetServerSideProps } from "@/utils/createGetServerSideProps";

import Breadcrumb from "@/components/Breadcrumb";
import Breadcrumbs from "@/components/Breadcrumbs";
import DealsDisclaimer from "@/components/DealsDisclaimer";
import DealsHero from "@/components/DealsHero";
import LocationsGrid, { Locations } from "@/components/LocationsGrid";
import MetaTags from "@/components/MetaTags";

type LocationsPageProps = { locations: Locations };

const LocationsPage: React.FC<LocationsPageProps> = ({ locations }) => (
  <>
    <MetaTags
      title="Weed Deals in a City Near You | Leafly"
      description="Find a list of dispensary deals in a city near or far from you using our deals location page. Get discounts on flower, dabs, carts, and edibles with Leafly."
    />

    <div className="container mt-xl mb-xxl">
      <h1 className="mb-lg">Dispensary deals in a city near you</h1>

      <DealsHero className="mb-section" />

      <LocationsGrid locations={locations} className="mb-section" />

      <DealsDisclaimer />
    </div>

    <Breadcrumbs className="mt-xl">
      <Breadcrumb href="/deals">Deals</Breadcrumb>

      <Breadcrumb currentLocation href="/deals/locations">
        All locations
      </Breadcrumb>
    </Breadcrumbs>
  </>
);

export const getServerSideProps = createGetServerSideProps<LocationsPageProps>(
  async () => {
    return {
      props: {
        locations,
      },
    };
  },
);

export default LocationsPage;
